export default __webpack_public_path__ + "static/media/bl.d092f93b.svg";